import { baseApiHeaders, HIDE_TOAST_KEY, type IApiResponse, type INotification, type ParamType } from 'BreetHelpers';

import { apiSlice } from './apiSlice';

export const notificationsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getNotifications: builder.query<IApiResponse<INotification[]>, ParamType>({
			query: (params) => ({ url: '/notifications', params }),
			providesTags: ['GetNotifications'],
		}),
		deleteNotifications: builder.mutation<IApiResponse, { body: Record<string, string[]>; params: string }>({
			query: ({ body, params }) => ({
				method: 'DELETE',
				url: `/notifications${params}`,
				body,
				headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' },
			}),
			invalidatesTags: ['GetNotifications'],
		}),
		markNotificationAsRead: builder.mutation<IApiResponse, Record<string, string[]>>({
			query: (body) => ({
				method: 'PATCH',
				url: '/notifications',
				body,
				headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' },
			}),
			invalidatesTags: ['GetNotifications'],
		}),
		addFCMToken: builder.mutation<IApiResponse, { token: string }>({
			query: (body) => ({
				method: 'PUT',
				url: '/notifications/token/add',
				body,
				headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' },
			}),
		}),
		removeFCMToken: builder.mutation<IApiResponse, { token: string }>({
			query: (body) => ({
				method: 'PUT',
				url: '/notifications/token/remove',
				body,
				headers: { ...baseApiHeaders, [HIDE_TOAST_KEY]: 'true' },
			}),
		}),
	}),
});

export const {
	useGetNotificationsQuery,
	useDeleteNotificationsMutation,
	useMarkNotificationAsReadMutation,
	useAddFCMTokenMutation,
	useRemoveFCMTokenMutation,
} = notificationsApiSlice;
